import { put, select, takeEvery } from '@redux-saga/core/effects';
import cloneDeep from 'lodash.clonedeep';
import {
  SET_ELEMENT_FILL,
  SET_ELEMENT_GRADIENT_TYPE,
  SET_ELEMENT_OPACITY,
  SET_ELEMENT_GRADIENT_COLOR,
  SET_ELEMENT_COLOR,
  SET_ELEMENT_UNLOCKED_RATIO,
  SET_ELEMENT_FLIP_X,
  SET_ELEMENT_FLIP_Y,
  SET_ELEMENT_TEXT_ALIGN,
  SET_ELEMENT_TEXT_BOLD,
  SET_ELEMENT_TEXT_ITALIC,
  SET_ELEMENT_TEXT_FONT,
  SET_ELEMENT_IMAGE_RECOLOR,
  CLEAR_ELEMENT_IMAGE_RECOLOR
} from 'JS/actionCreators/elementActions';
import { updateScribe } from 'JS/actionCreators/scribeActions';
import applyImageRecolor from 'JS/sagas/sagaHelpers/applyImageRecolor';

import { getScribeById } from './selectors';

export function* updateElementProperty({ scribeId, elementIds = [], update }) {
  const scribe = yield select(getScribeById, scribeId);

  if (!scribe) return;

  const elementsIdsToUpdate = Array.isArray(elementIds) ? elementIds : [elementIds];
  const updatedScribe = cloneDeep(scribe);
  const elementsToUpdate = updatedScribe.elements.filter(el => elementsIdsToUpdate.includes(el.id));

  if (!elementsToUpdate.length) return;

  elementsToUpdate.forEach(element => {
    const updateIndex = updatedScribe.elements.findIndex(el => el.id === element.id);
    updatedScribe.elements[updateIndex] = { ...element, ...update };
  });

  yield put(updateScribe(updatedScribe));
}

export function* setElementImageRecolor({ scribeId, elementId, layer, value }) {
  const scribe = yield select(getScribeById, scribeId);

  if (!scribe) return;

  const updatedScribe = cloneDeep(scribe);
  const elementToUpdate = updatedScribe.elements.find(el => el.id === elementId);

  if (!elementToUpdate) return;

  if (!elementToUpdate.image.recolor) elementToUpdate.image.recolor = {};
  elementToUpdate.image.recolor[layer] = value;

  yield applyImageRecolor(elementToUpdate);

  yield put(updateScribe(updatedScribe));
}

export function* clearElementImageRecolor({ scribeId, elementId }) {
  const scribe = yield select(getScribeById, scribeId);

  if (!scribe) return;

  const updatedScribe = cloneDeep(scribe);
  const elementToUpdate = updatedScribe.elements.find(el => el.id === elementId);

  if (!elementToUpdate) return;

  elementToUpdate.image.recolor = {};

  yield applyImageRecolor(elementToUpdate);

  yield put(updateScribe(updatedScribe));
}

export default function* elementSagas() {
  yield takeEvery(
    [
      SET_ELEMENT_OPACITY,
      SET_ELEMENT_FILL,
      SET_ELEMENT_GRADIENT_TYPE,
      SET_ELEMENT_GRADIENT_COLOR,
      SET_ELEMENT_COLOR,
      SET_ELEMENT_UNLOCKED_RATIO,
      SET_ELEMENT_FLIP_X,
      SET_ELEMENT_FLIP_Y,
      SET_ELEMENT_TEXT_ALIGN,
      SET_ELEMENT_TEXT_BOLD,
      SET_ELEMENT_TEXT_ITALIC,
      SET_ELEMENT_TEXT_FONT
    ],
    updateElementProperty
  );
  yield takeEvery(SET_ELEMENT_IMAGE_RECOLOR, setElementImageRecolor);
  yield takeEvery(CLEAR_ELEMENT_IMAGE_RECOLOR, clearElementImageRecolor);
}
